export default __webpack_public_path__ + "static/1-c7f0d2b4985433c5afe03b50af810f4e.webp";